const ISO_COUNTRIES = [
  // eslint-disable-next-line prettier/prettier
  'AF', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AQ', 'AG', 'AR', 'AM', 'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BQ', 'BA', 'BW', 'BR', 'IO', 'BN', 'BG', 'BF', 'BI', 'KH', 'CM', 'CA', 'CV', 'KY', 'CF', 'TD', 'CL', 'CN', 'CX', 'CC', 'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'CI', 'HR', 'CU', 'CW', 'CY', 'CZ', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET', 'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'DE', 'GH', 'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'HM', 'VA', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'IR', 'IQ', 'IE', 'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KP', 'KR', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP', 'NL', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NU', 'NF', 'MK', 'MP', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'PR', 'QA', 'RE', 'RO', 'RU', 'RW', 'BL', 'SH', 'KN', 'LC', 'MF', 'PM', 'VC', 'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SX', 'SK', 'SI', 'SB', 'SO', 'ZA', 'GS', 'SS', 'ES', 'LK', 'SD', 'SR', 'SJ', 'SE', 'CH', 'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TR', 'TM', 'TC', 'TV', 'UG', 'UA', 'AE', 'GB', 'US', 'UM', 'UY', 'UZ', 'VU', 'VE', 'VN', 'VG', 'VI', 'WF', 'EH', 'YE', 'ZM', 'ZW'
];

const regionNames = new Intl.DisplayNames(
  ['en'], // or 'pt-PT', 'fr', etc.
  { type: 'region' }
);

export const countries = ISO_COUNTRIES.map((value) => ({
  value,
  label: regionNames.of(value),
}));

export const getCountryName = (countryCode: string) => {
  try {
    return regionNames.of(countryCode);
  } catch (error) {
    console.error('Error getting country name:', error);
    return null; // Or handle the error as appropriate
  }
};

export const USStates = [
  { value: 'US-AL', label: 'Alabama' },
  { value: 'US-AK', label: 'Alaska' },
  { value: 'US-AZ', label: 'Arizona' },
  { value: 'US-AR', label: 'Arkansas' },
  { value: 'US-CA', label: 'California' },
  { value: 'US-CO', label: 'Colorado' },
  { value: 'US-CT', label: 'Connecticut' },
  { value: 'US-DE', label: 'Delaware' },
  { value: 'US-FL', label: 'Florida' },
  { value: 'US-GA', label: 'Georgia' },
  { value: 'US-HI', label: 'Hawaii' },
  { value: 'US-ID', label: 'Idaho' },
  { value: 'US-IL', label: 'Illinois' },
  { value: 'US-IN', label: 'Indiana' },
  { value: 'US-IA', label: 'Iowa' },
  { value: 'US-KS', label: 'Kansas' },
  { value: 'US-KY', label: 'Kentucky' },
  { value: 'US-LA', label: 'Louisiana' },
  { value: 'US-ME', label: 'Maine' },
  { value: 'US-MD', label: 'Maryland' },
  { value: 'US-MA', label: 'Massachusetts' },
  { value: 'US-MI', label: 'Michigan' },
  { value: 'US-MN', label: 'Minnesota' },
  { value: 'US-MS', label: 'Mississippi' },
  { value: 'US-MO', label: 'Missouri' },
  { value: 'US-MT', label: 'Montana' },
  { value: 'US-NE', label: 'Nebraska' },
  { value: 'US-NV', label: 'Nevada' },
  { value: 'US-NH', label: 'New Hampshire' },
  { value: 'US-NJ', label: 'New Jersey' },
  { value: 'US-NM', label: 'New Mexico' },
  { value: 'US-NY', label: 'New York' },
  { value: 'US-NC', label: 'North Carolina' },
  { value: 'US-ND', label: 'North Dakota' },
  { value: 'US-OH', label: 'Ohio' },
  { value: 'US-OK', label: 'Oklahoma' },
  { value: 'US-OR', label: 'Oregon' },
  { value: 'US-PA', label: 'Pennsylvania' },
  { value: 'US-RI', label: 'Rhode Island' },
  { value: 'US-SC', label: 'South Carolina' },
  { value: 'US-SD', label: 'South Dakota' },
  { value: 'US-TN', label: 'Tennessee' },
  { value: 'US-TX', label: 'Texas' },
  { value: 'US-UT', label: 'Utah' },
  { value: 'US-VT', label: 'Vermont' },
  { value: 'US-VA', label: 'Virginia' },
  { value: 'US-WA', label: 'Washington' },
  { value: 'US-WV', label: 'West Virginia' },
  { value: 'US-WI', label: 'Wisconsin' },
  { value: 'US-WY', label: 'Wyoming' },
];

export const getUSStateName = (stateCode: string) => USStates.find((s) => s.value === stateCode)?.label || stateCode;
